<p-dialog header="" [(visible)]="visible" [closeOnEscape]="false" [closable]="false"  [modal]="true">
  <div class="loader-container">
    <div class="logo">
      <!-- <span class="orange">Je</span><span class="black">Suis</span><span class="orange">En</span><span class="black">Cours</span> -->
      <p>{{ 'Wait' | translate }}</p>
    </div>
    <div class="loader">
      <div id="floatingCirclesG">
        <div class="f_circleG" id="frotateG_01"></div>
        <div class="f_circleG" id="frotateG_02"></div>
        <div class="f_circleG" id="frotateG_03"></div>
        <div class="f_circleG" id="frotateG_04"></div>
        <div class="f_circleG" id="frotateG_05"></div>
        <div class="f_circleG" id="frotateG_06"></div>
        <div class="f_circleG" id="frotateG_07"></div>
        <div class="f_circleG" id="frotateG_08"></div>
      </div>
    </div>
  </div>
</p-dialog>